import { JOOR_PAY_ORDERS_PREFIX } from 'featurePrefix.ids'

const SEND_PAYMENT_REQUEST_MODAL = 'send-payment-request-modal'

// pendo ids...
export const sendPaymentRequestIds = {
  radioButton: `${JOOR_PAY_ORDERS_PREFIX}__${SEND_PAYMENT_REQUEST_MODAL}__pay-remaining-balance`,
  numericInputValue: `${JOOR_PAY_ORDERS_PREFIX}__${SEND_PAYMENT_REQUEST_MODAL}__numeric-input-value`,
  numericInputPercentage: `${JOOR_PAY_ORDERS_PREFIX}__${SEND_PAYMENT_REQUEST_MODAL}__numeric-input-percentage`,
  bccEmailField: `${JOOR_PAY_ORDERS_PREFIX}__${SEND_PAYMENT_REQUEST_MODAL}__bcc-email-field`,
  closeButton: `${JOOR_PAY_ORDERS_PREFIX}__${SEND_PAYMENT_REQUEST_MODAL}__close-button`,
  copyLinkButton: `${JOOR_PAY_ORDERS_PREFIX}__${SEND_PAYMENT_REQUEST_MODAL}__copy-link-button`,
  goBackButton: `${JOOR_PAY_ORDERS_PREFIX}__${SEND_PAYMENT_REQUEST_MODAL}__go-back-button`,
  sendCustomizedRequestButton: `${JOOR_PAY_ORDERS_PREFIX}__${SEND_PAYMENT_REQUEST_MODAL}__combo-button`,
  comboButtonAutomated: `${JOOR_PAY_ORDERS_PREFIX}__${SEND_PAYMENT_REQUEST_MODAL}__send-automated-request-button`,
  comboButtonCustomized: `${JOOR_PAY_ORDERS_PREFIX}__${SEND_PAYMENT_REQUEST_MODAL}__send-customized-request-button`,
  detailsTab: `${JOOR_PAY_ORDERS_PREFIX}__${SEND_PAYMENT_REQUEST_MODAL}__details-tab`,
  emailPreview: `${JOOR_PAY_ORDERS_PREFIX}__${SEND_PAYMENT_REQUEST_MODAL}__email-preview-tab`,
  // this is a shared component with the ext payments modal. might want to rename/replace this id later
  attachInvoice: `${JOOR_PAY_ORDERS_PREFIX}__${SEND_PAYMENT_REQUEST_MODAL}__attach-invoice`,
  attachJoorInvoice: `${JOOR_PAY_ORDERS_PREFIX}__${SEND_PAYMENT_REQUEST_MODAL}__attach-joor-invoice`,
  cancelAttachJoorInvoice: `${JOOR_PAY_ORDERS_PREFIX}__${SEND_PAYMENT_REQUEST_MODAL}__cancel-attach-joor-invoice`,
} as const
